<template>
    <DialogBlockWrapper
        :onEdit="onEditBtnClick"
        :onSave="onSubmitBtnClick"
        :onCancel="onCancelBtnClick"
        :isEditMode="mode === 'edit'"
        :enableEdit="enable && !isQR()"
        :size="size"
        style="align-items: flex-start"
    >
        <template>
            <div v-if="mode === 'view'">
                <span class="item-title" :class="{ danger: !itemSno }">{{ title }}</span>
                <span v-if="itemSno">
                    {{ hierarchyItemNames }}
                </span>
                <span v-else style="color: red; font-weight: bold">（尚未選擇支出項目）</span>
            </div>
            <div v-if="mode === 'edit'">
                <div style="display: flex">
                    <span class="item-title" :class="{ danger: !itemSno }">{{ title }}</span>
                    <div>
                        <ahSelectVariableStateItem
                            ref="ahSelectVariableStateItem"
                            hide-tip
                            size="mini"
                            v-model="editingItemSno"
                            :enableType="this.enableTypes"
                            non-clearable
                            @change="onVariableStateItemChange"
                        />
                        <ahSuggestAccountingItemsSelector
                            v-if="isAhSuggestAccountingItemsSelectorShow"
                            ref="ahSuggestAccountingItemsSelector"
                            size="mini"
                            v-model="accno"
                            @loaded="onAhSuggestAccountingItemsSelectorLoaded"
                        ></ahSuggestAccountingItemsSelector>
                    </div>
                </div>
            </div>
        </template>
    </DialogBlockWrapper>
</template>
<script>
import ahSelectVariableStateItem from '@/components/ui/ahSelectVariableStateItem.vue';
import ahSuggestAccountingItemsSelector from '@/components/ui/ahSuggestAccountingItemsSelector.vue';
import DialogBlockWrapper from './DialogBlock/DialogBlockWrapper.vue';

export default {
    name: 'StateItemInlineEditor',
    components: {
        DialogBlockWrapper,
        ahSelectVariableStateItem,
        ahSuggestAccountingItemsSelector,
    },
    props: {
        type: {
            Type: String,
            default: 'payment', // payment | invoice
        },
        sno: {
            Type: Number,
            default: null,
        },
        receiptAccno: {
            Type: Number,
            default: null,
        },
        itemSno: {
            Type: Number,
            default: null,
        },
        enable: {
            Type: Boolean,
            default: false,
        },
        size: {
            Type: String,
            default: 'normal',
        },
        allowEmpty: Boolean,
    },
    data() {
        return {
            isAhSuggestAccountingItemsSelectorShow: true,

            mode: 'view', // view | edit
            editingItemSno: null,
            originalItemSno: null,
            isSubmitting: false,
            accno: null,
            suggestAccountItems: [],
        };
    },
    computed: {
        title() {
            if (this.type === 'payment') return '支出項目';
            return '收入項目';
        },
        enableTypes() {
            if (this.type === 'payment') {
                return ['payout', 'cOut', 'cOutElse'];
            }
            if (this.type === 'invoice') {
                return ['invoice'];
            }
            return [];
        },
        statementOptionsForUi() {
            return this.$store.getters['statement/statementUiOptions'];
        },
        statementOptions() {
            return this.$store.getters['statement/statementOptions'];
        },
        hierarchyItemNames() {
            const hierarchy = [null, null, null];

            const types = [
                { key: 'payoutSettings', name: '營業支出' },
                { key: 'invoiceSettings', name: '營業收入' },
                { key: 'cInSettings', name: '營業其他收入' },
                { key: 'cInElseSettings', name: '財務資產收入' },
                { key: 'cOutSettings', name: '營業其他支出' },
                { key: 'cOutElseSettings', name: '財務資產支出' },
            ];

            for (const t in types) {
                const options = this.statementOptionsForUi[types[t].key];
                for (const i in options) {
                    const lv1Item = options[i];
                    for (const j in lv1Item.childSettings) {
                        const lv2Item = lv1Item.childSettings[j];
                        if (lv2Item.sno === this.itemSno) {
                            hierarchy[0] = types[t].name;
                            hierarchy[1] = lv1Item.iteM_NAM;
                            hierarchy[2] = lv2Item.iteM_NAM;
                            break;
                        }
                    }
                }
            }

            return hierarchy.join(' / ');
        },
    },
    methods: {
        onEditBtnClick() {
            this.isAhSuggestAccountingItemsSelectorShow = true;
            this.editingItemSno = this.itemSno;
            this.originalItemSno = this.itemSno;
            this.accno = this.receiptAccno;
            this.mode = 'edit';
            this.$nextTick(() => {
                this.$refs.ahSuggestAccountingItemsSelector.init(this.itemSno);
            });
            this.accno = this.receiptAccno;
        },
        onCancelBtnClick() {
            this.mode = 'view';
            this.editingItemSno = null;
        },
        onSubmitBtnClick() {
            if (!this.allowEmpty && !this.editingItemSno) {
                this.$message({
                    showClose: true,
                    message: '請選擇收支項目',
                    type: 'error',
                });
                return;
            }
            if (this.editingItemSno === this.originalItemSno && this.accno === this.receiptAccno) {
                this.mode = 'view';
                return;
            }
            this.submit();
        },
        async submit() {
            this.isSubmitting = true;

            let apiUrl = 'PaymentManagenmentPage/ModifyItemNo';

            if (this.type === 'invoice') {
                apiUrl = 'InvoiceManagemnetPage/ModifyIncomeNo';
            }

            try {
                await this.$api({
                    url: apiUrl,
                    method: 'POST',
                    data: {
                        sno: this.sno,
                        incomeItemNo: this.editingItemSno,
                        accno: this.accno,
                    },
                });

                this.mode = 'view';
                this.editingItemSno = null;
                this.$emit('changed');
            } catch (e) {
                this.$message.error('無法更改');
                console.log('ModifyItemNo Error:', e);
            } finally {
                this.isSubmitting = false;
            }
        },
        onVariableStateItemChange(val) {
            this.isAhSuggestAccountingItemsSelectorShow = true;
            this.$nextTick(() => {
                this.$refs.ahSuggestAccountingItemsSelector.setSuggestAccountItems(val);
            });
        },
        onAhSuggestAccountingItemsSelectorLoaded(show) {
            this.isAhSuggestAccountingItemsSelectorShow = show && (this.isPayed('G01') || this.$store.getters['account/isSAAdmin']);
        },
    },
};
</script>
<style lang="scss">
.item-title {
    color: #463cb2;
    font-weight: bold;
    margin-right: 15px;

    &.danger {
        color: red;
    }
}
</style>
